import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "error"]

  submit(event) {
    event.preventDefault()
    const form = this.formTarget
    const data = new FormData(form)
    const csrf = document.querySelector('meta[name="csrf-token"]').content

    fetch(form.action, {
      method: "POST",
      headers: { Accept: "application/json", "X-CSRF-Token": csrf },
      body: data,
    })
      .then((r) => r.json())
      .then((json) => {
        if (json.success) {
          const bsModal = window.bootstrap && bootstrap.Modal.getInstance(document.getElementById("exampleModal"))
          if (bsModal) bsModal.hide()
          form.reset()
          const overlay = document.getElementById("cnSuccessModal")
          if (overlay) overlay.style.display = "flex"
        } else {
          this.#showError(json.error || "Error al enviar el mensaje.")
        }
      })
      .catch(() => this.#showError("Error de conexión. Intente nuevamente."))
  }

  #showError(msg) {
    if (this.hasErrorTarget) this.errorTarget.textContent = msg
  }
}
